export default __webpack_public_path__ + "static/media/1.a1f0bac0.png";